module.exports = __webpack_public_path__ + "static/determined-site-header-queencenter-67bdc25850ea6d4d81e49c52f42734cc.jpg";